import { useMemo } from 'react';
import { useChatStore } from '../../chatStore';
import type { ConversationRuntimeState } from './runtimeState';

export interface UseConversationRuntimeResult {
  runtime: ConversationRuntimeState | null;
  isStreaming: boolean;
  isUploading: boolean;
}

export function useConversationRuntime(
  conversationId?: string | null,
): UseConversationRuntimeResult {
  const runtime = useChatStore((s) => (
    conversationId ? (s.conversationRuntimes[conversationId] ?? null) : null
  ));
  const isStreaming = useChatStore((s) => s.isStreaming(conversationId));
  const isUploading = useChatStore((s) => s.isUploadingConversation(conversationId));

  return useMemo(() => ({
    runtime,
    isStreaming,
    isUploading,
  }), [isStreaming, isUploading, runtime]);
}
